import { FC } from "react";
import { DynamicSeo } from "seo";
import { Card, CardGrid, Headline, Section } from "ui";
import { transformDate } from "../transformDate";
import { StoryBaseProps } from "../types/StoryBaseProps";

export interface PostOverviewProps {
	title?: string;
	overViewData?: any;
}

interface StoryPostOverviewProps extends StoryBaseProps<PostOverviewProps> {
	overViewData: any;
}

export const StoryPostOverview: FC<StoryPostOverviewProps> = ({ blok }) => {
	const { title, overViewData } = blok;
	return (
		<>
			<DynamicSeo title={title} />
			<Section contentFullWidth={true}>
				<Headline level={1}>{title}</Headline>
				<CardGrid>
					{overViewData &&
						overViewData.length > 0 &&
						overViewData.map(({ title, date, full_slug, image }, index) => {
							return (
								<Card
									title={title}
									subTitle={transformDate(date)}
									href={full_slug}
									imageSrc={image?.filename ?? ""}
									imageAlt={image?.alt ?? ""}
									key={index}
								/>
							);
						})}
				</CardGrid>
			</Section>
		</>
	);
};
